// AI-CONTEXT: See docs/features/platform-revenue-churn-trend.md
// AI-CONTEXT: See docs/patterns.md#dashboard-static-card
import { useHistory } from 'react-router-dom'
import { client } from '../../hooks/Client'
import usePlatformChurn from '../../hooks/usePlatformChurn'
import StaticCardLabel from './StaticCardLabel'
import KpiValue from './KpiValue'

/**
 * KPI-tegel met de churn (Deccos-beheertenant): hoeveel klanten deze maand op
 * 'Gestopt' zijn gezet, met het totaal eronder.
 *
 * Churn = de stand 'Gestopt' in het abonnementenoverzicht (besluit
 * 2026-10-06), niet een project op inactief in het projectenoverzicht.
 *
 * Nul is hier een echte nul en geen streepje: de lijst achter het getal is
 * volledig — iedereen die nu op Gestopt staat zit erin. Alleen een mislukte
 * ophaling geeft een streepje, met de fout eronder.
 * AI-CONTEXT: See docs/pitfalls.md#ui-empty-state-claims-absence-while-loading
 *
 * Het getal én de knop onderaan openen de detailpagina met de notities. Geen
 * klikbare tegel: die zit in een sleepbaar raster (zie DashboardMrrCard).
 *
 * Neemt geen props: de tegel toont één vaste metric.
 */
const DashboardChurnCard = () => {
    const routerHistory = useHistory()
    const { churn, loading, error } = usePlatformChurn()

    const openDetail = () => routerHistory.push(`/${client}/platformChurn`)
    const value = churn && Number.isFinite(churn.thisMonth) ? String(churn.thisMonth) : null

    return (
        <div className='participation-value-card'>
            <StaticCardLabel title='Churn' pill={{ variant: 'msi', label: 'Deccos' }} />

            <KpiValue
                loading={loading}
                value={value}
                onClick={openDetail}
                ariaLabel='Gestopte klanten deze maand'
            />

            {error && !loading && (
                <p className='participation-value-note participation-value-note--error'>{error}</p>
            )}

            {churn && !loading && (
                <p className='participation-value-change neutral'>
                    {`deze maand · ${churn.total} gestopt in totaal`}
                </p>
            )}

            <button
                type='button'
                className='participation-value-link'
                aria-label='Alle gestopte klanten'
                onClick={openDetail}
            >
                Gestopte klanten →
            </button>
        </div>
    )
}

export default DashboardChurnCard
